// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  bindingId: __t.u64().primaryKey().name("binding_id"),
  twinId: __t.string().name("twin_id"),
  dofName: __t.string().name("dof_name"),
  sourceKind: __t.string().name("source_kind"),
  sourceName: __t.string().name("source_name"),
  constantValue: __t.f64().name("constant_value"),
  kind: __t.string(),
  inMin: __t.f64().name("in_min"),
  inMax: __t.f64().name("in_max"),
  outMin: __t.f64().name("out_min"),
  outMax: __t.f64().name("out_max"),
  transitionSeconds: __t.f64().name("transition_seconds"),
  idleTimeoutSeconds: __t.f64().name("idle_timeout_seconds"),
});
